/* Titta · Reseñas (Revie) + reseña destacada rotativa */
(function () {
  'use strict';
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];

  function parse(v) { if (typeof v === 'string') { try { return JSON.parse(v); } catch (e) { return null; } } return v; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function name(r) {
    var c = r.customer || {};
    var f = (c.firstName || 'Clienta').trim().split(' ')[0];
    var l = (c.lastName || '').trim();
    f = f.charAt(0).toUpperCase() + f.slice(1).toLowerCase();
    return f + (l ? ' ' + l.charAt(0).toUpperCase() + '.' : '');
  }
  function date(r) {
    var d = new Date((r.createdAt || '').replace(' ', 'T'));
    return isNaN(d) ? '' : MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }
  function imgs(r) { return (r.images || []).filter(function (i) { return i && i.src && i.active !== false; }).map(function (i) { return i.src; }); }
  function stars(n) { var s = ''; for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆'; return s; }
  function score(r) { var t = (r.comment || '').length; return (imgs(r).length ? 1000 : 0) + (r.stars || 0) * 100 + Math.min(t, 300); }

  function load() {
    var el = document.querySelector('[data-reviews-json]');
    if (!el) return null;
    var j = parse(el.textContent);
    if (!j) return null;
    var list = parse(j.list) || [];
    var data = parse(j.data) || {};
    list = list.filter(function (r) { return r && r.stars && (r.comment || imgs(r).length); });
    return { list: list, data: data };
  }

  function initReviews(root, R) {
    var grid = root.querySelector('[data-reviews-grid]'), more = root.querySelector('[data-reviews-more]'),
        bars = root.querySelector('[data-reviews-bars]'), ugc = root.querySelector('[data-reviews-ugc]'),
        ugcTrack = root.querySelector('[data-reviews-ugc-track]'), lb = root.querySelector('[data-reviews-lightbox]');
    var PAGE = window.matchMedia('(min-width: 750px)').matches ? 9 : 4;
    var sorted = R.list.slice().sort(function (a, b) { return score(b) - score(a); });
    var filter = 'all', shown = 0;

    // Barras de distribución
    var dist = {}, total = 0;
    (R.data.stars || []).forEach(function (s) { dist[s.star] = +s.count; total += +s.count; });
    [5, 4, 3, 2, 1].forEach(function (n) {
      var c = dist[n] || 0, pct = total ? Math.round(c / total * 100) : 0;
      var li = document.createElement('li');
      li.innerHTML = '<span>' + n + ' ★</span><span class="titta-reviews__bar"><span style="width:' + pct + '%"></span></span><span>' + c + '</span>';
      bars.appendChild(li);
    });

    // Fotos de clientas
    var withPh = sorted.filter(function (r) { return imgs(r).length; });
    if (withPh.length) {
      ugc.hidden = false;
      withPh.forEach(function (r) {
        imgs(r).slice(0, 1).forEach(function (src) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'titta-reviews__ugc-item';
          b.innerHTML = '<img loading="lazy" src="' + esc(src) + '" alt="Foto de ' + esc(name(r)) + '">';
          b.addEventListener('click', function () { openLb(src, r); });
          ugcTrack.appendChild(b);
        });
      });
    }

    function openLb(src, r) {
      lb.querySelector('[data-lightbox-img]').src = src;
      lb.querySelector('[data-lightbox-txt]').innerHTML = '<div class="titta-reviews__stars">' + stars(r.stars) + '</div><p>' + esc(r.comment) + '</p><p class="titta-reviews__name">' + esc(name(r)) + '</p>';
      lb.showModal ? lb.showModal() : lb.setAttribute('open', '');
    }
    lb.querySelector('[data-lightbox-close]').addEventListener('click', function () { lb.close(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });

    function current() {
      return sorted.filter(function (r) {
        if (filter === 'photos') return imgs(r).length;
        if (filter === 'all') return true;
        return String(r.stars) === filter;
      });
    }
    function card(r) {
      var ph = imgs(r);
      var d = document.createElement('article');
      d.className = 'titta-rcard';
      d.innerHTML =
        '<div class="titta-rcard__top"><span class="titta-reviews__stars" aria-label="' + r.stars + ' de 5">' + stars(r.stars) + '</span><span class="titta-rcard__date">' + date(r) + '</span></div>' +
        (r.comment ? '<p class="titta-rcard__txt">' + esc(r.comment) + '</p>' : '') +
        (ph.length ? '<button type="button" class="titta-rcard__ph"><img loading="lazy" src="' + esc(ph[0]) + '" alt="Foto de ' + esc(name(r)) + '"></button>' : '') +
        '<p class="titta-reviews__name">' + esc(name(r)) + '</p>' +
        (r.commentResponse ? '<p class="titta-rcard__resp"><strong>Titta:</strong> ' + esc(r.commentResponse) + '</p>' : '');
      var b = d.querySelector('.titta-rcard__ph');
      if (b) b.addEventListener('click', function () { openLb(ph[0], r); });
      return d;
    }
    function render(reset) {
      var list = current();
      if (reset) { grid.innerHTML = ''; shown = 0; }
      list.slice(shown, shown + PAGE).forEach(function (r) { grid.appendChild(card(r)); });
      shown = Math.min(list.length, shown + PAGE);
      more.hidden = shown >= list.length;
    }
    root.querySelectorAll('[data-filter]').forEach(function (b) {
      b.addEventListener('click', function () {
        root.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        filter = b.dataset.filter; render(true);
      });
    });
    more.addEventListener('click', function () { render(false); });
    render(true);
  }

  function initQuotes(R) {
    document.querySelectorAll('[data-quotes]').forEach(function (q) {
      var min = +q.dataset.min || 60, max = +q.dataset.max || 190;
      var pool = R.list.filter(function (r) { var t = (r.comment || '').trim(); return r.stars === 5 && t.length >= min && t.length <= max; })
        .sort(function (a, b) { return score(b) - score(a); }).slice(0, 12);
      if (!pool.length) return;
      var t = q.querySelector('[data-quote-text]'), n = q.querySelector('[data-quote-name]'), i = 0;
      function show() {
        var r = pool[i % pool.length];
        q.classList.remove('is-in'); void q.offsetWidth;
        t.textContent = '“' + r.comment.trim() + '”';
        n.textContent = '— ' + name(r);
        q.classList.add('is-in'); i++;
      }
      q.hidden = false; show();
      if (pool.length > 1) setInterval(show, 6000);
    });
  }

  function init() {
    var R = load();
    if (!R || !R.list.length) return;
    document.querySelectorAll('[data-reviews]').forEach(function (root) { if (!root.dataset.rvInit) { root.dataset.rvInit = 1; initReviews(root, R); } });
    initQuotes(R);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
